module.exports = __webpack_public_path__ + "img/arcmet.ad9ec556.webp";